import _Vue, { PluginFunction, PluginObject } from 'vue';

import Segmentation from './Segmentation.vue';

export function SegmentationPlugin(Vue: typeof _Vue, options?: {}) {
  Vue.component('segmentation', Segmentation);
}
